export default "__VITE_ASSET__cd6cea5e__"